import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import QueryTags from "api/types/QueryTags";
import Species from "api/types/models/species";
import {
  GetSingleSpeciesRequest,
  GetSpeciesRequest,
  UpdateSingleSpeciesRequest,
} from "api/types/requests";
import PaginatedResponse from "api/types/PaginatedResponse";

const speciesEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getSingleSpecies: builder.query<Species, GetSingleSpeciesRequest>({
    query: ({ speciesUuid }) => ({ url: `/species/${speciesUuid}` }),
    providesTags: ["SingleSpecies"],
  }),

  getSpecies: builder.query<PaginatedResponse<Species[]>, GetSpeciesRequest>({
    query: ({ page, size, search, includeDisabled }) => ({
      url: "/species",
      params: {
        ...(page && { page }),
        ...(size && { size }),
        ...(search && { search }),
        ...(includeDisabled && { include_disabled: includeDisabled }),
      },
    }),
    providesTags: ["Species"],
  }),

  updateSingleSpecies: builder.mutation<Species, UpdateSingleSpeciesRequest>({
    query: ({ speciesUuid, body }) => ({
      url: `/species/${speciesUuid}`,
      method: "put",
      body,
    }),
    invalidatesTags: ["Species", "SingleSpecies"],
  }),
});

export default speciesEndpoints;
